export function toSentenceCase(str: string): string {
    return str.toLowerCase().replace(/(^\s*\w|[.!?]\s*\w)/g, (c) => {
        return c.toUpperCase();
    });
}